import axios from 'axios'
import airbrake from '@/helpers/airbrake'

const state = {
  remainingServiceTypes: null,
  progress: null,
  activeServiceType: null,
  pendingNonListing: null
}

const getters = {
}

const mutations = {
  SET_REMAINING (state, payload) {
    state.remainingServiceTypes = payload
  },
  SET_PROGRESS (state, pctComplete) {
    state.progress = pctComplete
  },
  SET_PENDING_NON_LISTING (state, serviceType) {
    state.pendingNonListing = serviceType
  },
  REMOVE_REMAINING (state, serviceTypes) {
    if (state.remainingServiceTypes.length) {
      let serviceTypeIds = serviceTypes.map((serviceType) => { return serviceType.id })
      state.remainingServiceTypes.forEach((st, index) => {
        if (serviceTypeIds.includes(st.id)) {
          if (state.activeServiceType && state.activeServiceType.id == st.id) {
            state.activeServiceType = state.remainingServiceTypes[index + 1]
          }
          state.remainingServiceTypes.splice(index, 1)
        }
      })
    }
  },
  SET_ACTIVE_SERVICE_TYPE (state, serviceType) {
    state.activeServiceType = serviceType
  }
}

const actions = {
  getRemaining ({commit}) {
    return axios.get('/list/service_types', {params: { remaining_askable: 1 }})
      .then((response) => {
        commit('SET_REMAINING', response.data)
      })
      .catch(err => {
        // Silently fail on API errors since we don't want to alarm the user
        // and allow them to still add providers outside of recommendations
        commit('SET_REMAINING', [])
        commit('SET_PROGRESS', 100)
        airbrake.notify(err)
      })
  },
  getProgress ({commit}) {
    return axios.get('/list/list_progress')
      .then((response) => {
        commit('SET_PROGRESS', response.data.percent_complete)
      })
  },
  removeRemaining ({commit, dispatch}, serviceTypes) {
    if (Array.isArray(serviceTypes)) {
      commit('REMOVE_REMAINING', serviceTypes)
    } else {
      commit('REMOVE_REMAINING', [serviceTypes])
    }
    dispatch('getProgress')
  },
  setActiveServiceType ({commit}, serviceType) {
    commit('SET_ACTIVE_SERVICE_TYPE', serviceType)
  },
  setPendingNonListing ({commit}, serviceType) {
    commit('SET_PENDING_NON_LISTING', serviceType)
  },
  cancelNonListing ({commit}) {
    commit('SET_PENDING_NON_LISTING', null)
  },
  createNonListing ({commit, dispatch}, serviceType) {
    return axios.post('/list/service_type_non_listings', {service_type_id: serviceType.id})
      .then(() => {
        commit('SET_PENDING_NON_LISTING', null)
        dispatch('removeRemaining', [serviceType])
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./frontend/src/store/modules/recommendations/index.js